/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ chain: NonNullable<unknown> }} Get_Listed_Dialog_Message_Text_Chain_Community_MemberInputs */



/**
* | output |
* | --- |
* | "We need {chain} listed on Chainspect! It’s where 50+ chains track metrics like TPS, decentralization, and traction. Would be awesome to see our stats there" |
*
* @param {Get_Listed_Dialog_Message_Text_Chain_Community_MemberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const get_listed_dialog_message_text_chain_community_member = /** @type {((inputs: Get_Listed_Dialog_Message_Text_Chain_Community_MemberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_Listed_Dialog_Message_Text_Chain_Community_MemberInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`We need ${i?.chain} listed on Chainspect! It’s where 50+ chains track metrics like TPS, decentralization, and traction. Would be awesome to see our stats there`)
});